import { NOT_SET, TrackingParameter } from '@sunrise/tracking'

import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'

const staticTealiumDataContact: TrackingParameter = {
    mslayer_element_data_id: TealiumTrackingIds.DETAIL_ACTIONS,
    mslayer_element_count: '2',
    mslayer_affiliate_id: NOT_SET,
    mslayer_element_company_name: NOT_SET,
    mslayer_element_detail_start_date: NOT_SET,
}

export function buildTealiumTracking(exposeeId: number): TrackingParameter {
    return {
        ...staticTealiumDataContact,
        mslayer_element_id: exposeeId.toString(),
    }
}
